import React from 'react';

const BreadcrumbsContext = React.createContext([]);

export default BreadcrumbsContext;
